import { Platform, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { colors } from '@ui/colors'
import Logo from '@shell/Logo'
import Status from '@ui/elements/Status'
import Gradient from '@ui/effects/Gradient'
import { OptionTier } from '@order/steps/types'
import { getLogoHeight, gradients, logos } from '@order/Package/styles'

interface Props {
  title?: string
  tier?: OptionTier
  size?: 'small' | 'default'
  isRecommended?: boolean
}

export default function PackageHead({
  title,
  tier = 'default',
  size = 'default',
  isRecommended = false,
}: Props) {
  const { t } = useTranslation(['ui'])

  const logo = logos[tier]
  const logoHeight = getLogoHeight(logo)
  const height = size === 'small' ? 64 : 72

  return (
    <>
      <View className="absolute inset-0 h-full w-full bg-black" />
      {gradients[tier].map((gradient, index) => (
        <Gradient key={index} {...gradient} />
      ))}
      <View className="px-8" style={{ height }}>
        <View className="flex flex-1 flex-row items-center justify-between">
          <View className="flex-0 flex" style={{ height: logoHeight }}>
            <Logo
              style={Platform.select({
                default: {
                  transformOrigin: 'top left',
                  transform: [{ scale: logoHeight / 32 }],
                },
                web: {
                  width: 'auto',
                  height: '100%',
                },
              })}
              name={logo}
            />
          </View>
          <View className="flex flex-row items-center justify-end gap-6">
            {isRecommended && (
              <Status
                text={t('ui:ourRecommendation')}
                colors={{ front: colors.white, back: colors.white0 }}
                className="relative h-7 border-2 border-white"
              />
            )}
            {!!title && (
              <Status
                text={title || ''}
                colors={{
                  front: colors.white,
                  back: colors.white25,
                }}
              />
            )}
          </View>
        </View>
      </View>
    </>
  )
}
